export default __webpack_public_path__ + "static/media/Logo.d19a2ee8.svg";